<span>{{ cellValue }}</span>
<span *ngIf="!productsV2" class="name-cell-renderer__select-all-box">
  <button
    [ngClass]="'name-cell-renderer__select-all'"
    (click)="selectAll($event)"
    type="button"
  >
    {{ "subscriptions." + selectedAll | translate }}
  </button>
</span>
